import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/e-signature-requests/{eSignatureRequestId}/file']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const handleFileAndSigners = async ({ eSignatureRequestId, ...body }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/e-signature-requests/${eSignatureRequestId}/file`, body);
  return response.data;
};

export default handleFileAndSigners;
